import React from 'react';

import { Surface } from '@infoods/lifebase-ui';

import classes from './ScanIqCustomerProfileCard.module.scss';
import { LbToggleTabsList, TabsConfig } from '../../../../../shared/components/tabs';
import { CustomerInfo } from './CustomerInfo/CustomerInfo';
import { AddScanButton } from './AddScanButton/AddScanButton';

type ScanIqCustomerProfileCardProps = {
  tabsConfig: TabsConfig[];
};

const ScanIqCustomerProfileCard = ({ tabsConfig }: ScanIqCustomerProfileCardProps) => {
  return (
    <Surface className={classes.container}>
      <div className={classes.customerInfo}>
        <CustomerInfo />
        <AddScanButton />
      </div>
      <LbToggleTabsList fullWidth tabsConfig={tabsConfig} />
    </Surface>
  );
};

export { ScanIqCustomerProfileCard };
